import { KindeSDK } from '@kinde-oss/react-native-sdk-0-7x';
import Config from 'react-native-config';

const createKindeClient = (): KindeSDK => {

  const requiredConfig = {
    issuerUrl: Config.KINDE_ISSUER_URL,
    callbackUrl: Config.KINDE_POST_CALLBACK_URL,
    clientId: Config.KINDE_CLIENT_ID,
    logoutUrl: Config.KINDE_POST_LOGOUT_REDIRECT_URL,
  };

  const missingKeys = Object.entries(requiredConfig)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missingKeys.length > 0) {
    throw new Error(`Kinde configuration incomplete: ${missingKeys.join(', ')}`);
  }
  return new KindeSDK(
    requiredConfig.issuerUrl as string,
    requiredConfig.callbackUrl as string,
    requiredConfig.clientId as string,
    requiredConfig.logoutUrl as string,
  );
};

export const KindeClient = createKindeClient();